import axiosClient from './axiosClient'
import queryString from 'query-string'

const userApi = {
    login: params => {
        return axiosClient.post('/auth/login', params)
    },
    loadUser: () => {
        return axiosClient.get('/auth')
    },
    logout: () => {
        return axiosClient.get('/auth/logout')
    },
    register: params => {
        return axiosClient.post('/auth/register', params)
    },
    activeEmail: params => {
        return axiosClient.post('/auth/active-email', params )
    },
    saveNews: params => {
        return axiosClient.put(`/user/${params}/save`)
    },
    removeNews: params => {
        return axiosClient.put(`/user/${params}/delete`)
    },
    getNewsSaved: params => {
        const paramsString = queryString.stringify(params);
        return axiosClient.get(`/user/news-saved?${paramsString}`)
    },
    getUserComments: params => {
        const paramsString = queryString.stringify(params);
        return axiosClient.get(`/user/comments?${paramsString}`)
    },
    updateProfile: params => {
        return axiosClient.patch('/user/update-profile', params)
    }
}

export default userApi